module.exports = __webpack_public_path__ + "static/media/mobile-app-image.2d911e7f.png";